<template>
  <div>
      <span v-if='debouncedApolloLoading' class="apollo-spinner text-green-500" />
        <!--
    <div class="relative mx-4 my-2">
      <magnify v-else :size='32' class="apollo-search left-0 " />
      <input type="search" class="w-full m-1 bg-purple-white shadow rounded border-0 p-3 pl-10" placeholder="Search videos..." v-model='search' >
    </div>
        -->

    <scrolling-video-gallery :videos='videos' :load-more='loadMore' v-on='$listeners' />

  </div>
</template>
<script>
import { uniqBy } from 'lodash';
//import Magnify from '@icons/Magnify.vue';
import Loading from '@ui/atoms/Loading.vue';
import { listVideosQuery } from '@/gql/Queries.js';
import ScrollingVideoGallery from './ScrollingVideoGallery.vue';

const pageSize = 10

export default {
  inject: ['api'],
  props: {
    gameId: {
      type: String,
      default: 'default'
    }
  },
  data() {
    return {
      search:'',
      from: 0,
      size: 50,
      debouncedApolloLoading: false,
      getVideos: {
        items: [],
        total: 0
      }
    }
  },
  apollo: {
    // Pages
    getVideos: {
      // GraphQL Query
      query: listVideosQuery,
      // Initial variables
      variables() {
        return {
          from: 0,
          size: this.size,
          search: this.apolloSearchString
        }
      }
    },
  },
  methods: {
    async loadMore() {
      //this.page++
      // Fetch more data and transform the original result
      const lengthBefore = this.getVideos.items.length;
      try {
        const result = await this.$apollo.queries.getVideos.fetchMore({
          // Transform the previous result with new data
          fetchPolicy: 'cache-and-network',
          variables: {
            from: this.videos.length,
            search: this.apolloSearchString,
            size: this.size
          },
          updateQuery: (previousResult, { fetchMoreResult }) => {
            const {getVideos} = fetchMoreResult;
            const newItems = getVideos.items;
            const total = getVideos.total;

            const items = uniqBy([...previousResult.getVideos.items, ...newItems], ({id}) => {
              return id;
            });
            return {
              getVideos: {
                __typename: previousResult.getVideos.__typename,
                // Merging the tag list
                items,
                total
              },
            }
          },
        })
        const currentLength = lengthBefore + result.data.getVideos.items.length;
        const total = result.data.getVideos.total;
        return total - currentLength;
      } catch (e) {
        console.error('error running graphql', e);
        return 0;
      }
    },
  },
  components: {
    ScrollingVideoGallery,
    //Magnify,
  },
  computed:{
    videos() {
      return this.getVideos.items.map( (video) => {
        return Object.assign({}, video, {
          url: this.api.makeVideoUrlEditor(video.id),
          thumbnailUrl: this.api.makeThumbnailUrlEditor(video.thumbnail),
        });
      });
    },
    apolloSearchString() {
      if (this.search && this.search.length) {
        return this.search;
      }
      return undefined;
    }
  },
  watch: {
    search() {
      this.from = 0;
    },
    '$apollo.loading'(nv) {
      if (!nv) {
        clearTimeout(this._debouncedApolloInterval);
        this._debouncedApolloInterval = null;
        this.debouncedApolloLoading = false;
      } else {
        clearTimeout(this._debouncedApolloInterval);
        this._debouncedApolloInterval = setTimeout( () => {
          this.debouncedApolloLoading = true;
          this._debouncedApolloInterval = null;
        }, 600);
      }
    }
  }
}
</script>

